import React from 'react'

function ErrorPage() {
  return (
    <div>Page not found | 404</div>
  )
}

export default ErrorPage